import { render, staticRenderFns } from "./mErrorDisplay.vue?vue&type=template&id=0494615c&scoped=true"
import script from "./mErrorDisplay.vue?vue&type=script&lang=ts"
export * from "./mErrorDisplay.vue?vue&type=script&lang=ts"
import style0 from "./mErrorDisplay.vue?vue&type=style&index=0&id=0494615c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0494615c",
  null
  
)

export default component.exports